









































import {
  Vue, Component,
} from 'vue-property-decorator';
import AdminVideoVaultCard from '@/components/admin/AdminVideoVaultCard.vue';
import brandModule from '../../store/modules/brand.module';
import { BrandAssetWrite } from '../../common/types';
import tagModule from '../../store/modules/tag.module';
import categoryModule from '../../store/modules/category.module';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import errorModule from '../../store/modules/error.module';
import adminModule from '../../store/modules/admin.module';
import { VIDEO_ID } from '../../common/config';

@Component({
  components: {
    AdminVideoVaultCard,
  },
})
export default class AdminVideoVault extends Vue {
  newAssetButtonPressed = false;

  newAsset: BrandAssetWrite = {
    title: '',
    description: '',
    tags: [],
    category: '',
    img: require('@/assets/admin/placeholder.jpg'),
    brand_id: '',
    featured: false,
  };

  brandModule = brandModule;

  get brandVideos() {
    if (!brandModule.brand) {
      return [];
    }
    if (!brandModule.brand.brand_assets) {
      return [];
    }
    const brandVideos = brandModule.brand.brand_assets.filter((asset) => {
      if (!asset.category) {
        return false;
      }
      return asset.category.id === VIDEO_ID;
    });
    return brandVideos;
  }

  async createAsset(payload) {
    const { asset } = payload;
    if (!brandModule.brand) {
      return;
    }
    const assetFile: File = payload.file;
    asset.brand_id = brandModule.brand.id;
    asset.img = assetFile.name;
    if (assetFile.type === 'image/gif') {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'GIF files are not supported in the Video Vault. Please upload in the Brand Center instead.',
      );
      return;
    }
    await brandModule.createBrandAsset({ asset, assetFile });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.newAssetButtonPressed = false;
    eventBus.$emit(SHOW_SNACKBAR, 'Video successfully uploaded.');
  }

  async updateAsset(payload) {
    const { asset } = payload;
    if (!brandModule.brand) {
      return;
    }
    const assetFile: File = payload.file;
    asset.brand_id = brandModule.brand.id;
    asset.img = assetFile.name;
    await brandModule.updateBrandAsset({ asset, assetFile });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.newAssetButtonPressed = false;
    eventBus.$emit(SHOW_SNACKBAR, 'Video successfully updated.');
    if (!adminModule.admin) {
      return;
    }
    const brandId = adminModule.admin.brand.id;
    await brandModule.fetchBrand(brandId);
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }

  async created(): Promise<void> {
    if (categoryModule.categories.length === 0) {
      await categoryModule.fetchCategories();
      if (errorModule.hasError) {
        errorModule.clearError();
      }
    }
    if (tagModule.tags.length === 0) {
      await tagModule.fetchTags();
      if (errorModule.hasError) {
        errorModule.clearError();
      }
    }
  }
}
